import './SystemMessage.css';
import {useActions} from "../../hooks/useActions";
import {useTypedSelector} from "../../hooks/useTypedSelector";
import React from "react";

function SystemMessage() {

    const {systemMessage} = useTypedSelector(state => state.auth);
    const {setSystemMessage} = useActions();

    let rootClasses = 'systemMessageContainer'
    if (systemMessage.isVisible) {
        rootClasses += ' systemMessageContainerActive';
    }

    const clickOk = () => {
        if (systemMessage.action !== null) {
            systemMessage.action();
        }
        setSystemMessage({isVisible: false, type: '', text: '', action: null});
    }


    const clickCancel = () => {

        if (systemMessage.actionCancel !== null) {
            systemMessage.actionCancel();
        }
        setSystemMessage({isVisible: false, type: '', text: '', action: null});
    }

    return <div className={rootClasses}>
        <div className={'systemMessageBox'}>

            <div className={'systemMessageText'}>{systemMessage.text}</div>

            <div className={'systemMessageButtonContainer'}>
                <div className='systemMessageButton systemMessageButtonOk' onClick={() => {
                    clickOk();
                }}>
                </div>
                {systemMessage.type === 'dialog' ?
                    <div className='systemMessageButton systemMessageButtonCansel' onClick={() => {
                        clickCancel();
                    }}>
                    </div>
                    :
                    <div></div>
                }
            </div>

        </div>
    </div>
}

export default SystemMessage